import AddressType from '@/models/AddressType';

export default class AddressTypeRepository {
    public static getAll() {
        return AddressType.all();
    }

    public static getById(id: string) {
        return AddressType.query().whereId(id).withAll().first();
    }

    public static getByCode(code: string) {
        return AddressType.query().where('code', code).first();
    }
}
